import { defineComponent } from 'vue';
import { isPC } from 'pk/service/Tools/ToolsService';
export default defineComponent({
  created() {
    if (isPC) {
      document.body.classList.add('PC-body');
    }
  }
});